<template>
  <div v-if="!produitArchive"
       class="card card-article has-background-table-second-color mgb-25px">
    <div v-if="produitVide">
      <div class="columns is-marginless is-paddingless">
        <div class="column is-3">
          <b-autocomplete
            v-model="produit.input"
            @focus="onFocus"
            :data="autocompleteProduitsList"
            field="label"
            :loading="isFetching"
            :open-on-focus="true"
            @select="item => selectProduit(item)"
            @input="getAsyncProduitData"
            :placeholder="$t('catalogue.actions.associerProduit')">
            <template #footer>
              <a @click="addProduitDivers">
                <span class="lien">
                  {{ $t('catalogue.actions.newProduitDivers') }}
                </span>
              </a>
            </template>
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('general.autocomplete.noRslt')}}
              </div>
              <div v-else>
                {{$t('general.autocomplete.search')}}
              </div>
            </template>
          </b-autocomplete>
        </div>
        <div class="column">
          <a class="is-pulled-right"
             @click="supprimerProduitLigne">
            <b-icon
              icon="delete-forever"
              type="is-danger">
            </b-icon>
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="columns is-marginless is-paddingless is-vcentered section-produit">
        <div class="column is-3">
          <router-link :to="{
              name: getLibelleAndRoutesForProduct(produit.produitEnfant).routeDetail,
              params: {id: produit.produitEnfant.id
            }}"
            class="lien"
            v-if="isDisabled"
            target="_blank"
            :class="{'text-access-no-permission':
            !checkPermissions(permCatalogue.lecture)}">
            {{ produit.libelle }}
          </router-link>
          <b-input :disabled="true" v-else
                   v-model="produit.libelle"></b-input>
        </div>
        <div class="column is-1-5">
          <b-field>
            <input-currency isNumber="true"
                            v-model="produit.quantite"
                            :disabled="true">
            </input-currency>
            <div class="control">
              <span class="select ">
                <select disabled>
                  <option>
                    {{ $t(unite(produit.uniteVente)) }}
                  </option>
                </select>
              </span>
            </div>
          </b-field>
        </div>
        <div class="column is-1-5">
          <input-currency isNumber="true"
                          :disabled="checkIfIsDisabled
                            || (produit.calculAutomatique
                            && displaySwitchCalculAutoTlpe(produit, false))"
                          v-model="produit.prixUnitaire">
          </input-currency>
        </div>
        <b-field v-if="displaySwitchTarifUnitaire()"
                 class="column is-1-5 mgb-0">
          <qd-switch :disabled="checkIfIsDisabled"
                    class="mgr-0"
                    v-model="produit.tarifUnitaire">
          </qd-switch>
          <div class="has-text-default" :class="isDisabled ? 'mgt-5px' : 'pdt-5px'">
            {{ $t('catalogue.tarifUnitaire') }}
          </div>
        </b-field>
        <b-datepicker show-week-number
                      nearby-selectable-month-days
                      :class="{'is-danger': startDateHasError}"
                      class="column is-1-5"
                      icon="calendar-today"
                      v-model="produit.dateDebut"
                      :editable='!checkIfIsDisabled'
                      :disabled=checkIfIsDisabled
        >
        </b-datepicker>
        <span>{{ $t('detailProduitReseau.to')}}</span>
        <b-datepicker show-week-number
                      icon="calendar-today"
                      class="column is-1-5"
                      :min-date="produit.dateDebut"
                      v-model="produit.dateFin"
                      nearby-selectable-month-days
                      :editable='!checkIfIsDisabled'
                      :disabled=checkIfIsDisabled>
        </b-datepicker>
        <b-field class="column is-1-5 mgb-0"
                 v-if="displaySwitchCalculAutoTlpe(produit, true)">
          <qd-switch :disabled="checkIfIsDisabled"
                    class="mgr-0"
                    @input="updateCalculAuto(produit)"
                    v-model="produit.calculAutomatique">
          </qd-switch>
          <div class="has-text-default" :class="isDisabled ? 'mgt-5px' : 'pdt-5px'">
            {{ $t('catalogue.calculAutoTlpe') }}
          </div>
        </b-field>
        <div class="column is-1-5 mgb-0"
             v-else-if="!isProduitReseauTempo">
        </div>
        <div class="column is-1" v-if="!isDisabled">
          <div class="columns">
              <a class="column is-6 has-text-centered"
                 @click="archiveProduitLigne">
                <b-icon
                  icon="archive"
                  type="is-primary">
                </b-icon>
              </a>
              <a @click="supprimerProduitLigne" class="column is-6 has-text-centered">
                <b-icon
                  icon="delete-forever"
                  type="is-danger">
                </b-icon>
              </a>
          </div>
        </div>
      </div>
      <template v-if="produitLocation">
        <div v-for="(produitEnfant, index) in produit.liaisonsTarif"
             :key="'child_' + index"
             class="columns is-marginless is-paddingless is-vcentered section-produit">
          <div class="column is-2 is-offset-1">
            <router-link :to="{
                name: getLibelleAndRoutesForProduct(produitEnfant.produitEnfant).routeDetail,
                params: {id: produitEnfant.produitEnfant.id
              }}"
              class="lien"
              target="_blank"
              v-if="isDisabled"
              :class="{'text-access-no-permission':
              !checkPermissions(permCatalogue.lecture)}">
              {{ produitEnfant.libelle }}
            </router-link>
            <b-input :disabled="true" v-else
                     v-model="produitEnfant.libelle"></b-input>
          </div>
          <div class="column is-1-5">
            <b-field>
              <input-currency isNumber="true"
                              v-model="produitEnfant.quantite"
                              :disabled="checkIfIsDisabled">
              </input-currency>
              <div class="control">
                <span class="select ">
                  <select disabled>
                    <option>
                      {{ $t(unite(produitEnfant.uniteVente)) }}
                    </option>
                  </select>
                </span>
              </div>
            </b-field>
          </div>
          <div class="column is-1-5">
            <input-currency isNumber="true"
                            :disabled="checkIfIsDisabled
                            || (produitEnfant.calculAutomatique
                            && displaySwitchCalculAutoTlpe(produitEnfant, false))"
                            v-model="produitEnfant.prixUnitaire">
            </input-currency>
          </div>
          <b-field class="column mgv-auto"
                   v-if="displaySwitchCalculAutoTlpe(produitEnfant, false)">
            <qd-switch :disabled="checkIfIsDisabled"
                      class="mgr-0"
                      @input="updateCalculAuto(produitEnfant)"
                      v-model="produitEnfant.calculAutomatique">
            </qd-switch>
            <b-field class="has-text-default">
              <span class="mgr-5px">
                {{ $t('catalogue.calculAutoTlpe') }}
              </span>
              <div v-if="getTypeTaxationTlpeId && produitEnfant.calculAutomatique"
                   @click="popUpInformationTarif = !popUpInformationTarif">
                <b-icon custom-size="mdi-18px"
                  type="is-primary" icon="information"
                  class="is-cursor-pointer">
                </b-icon>
              </div>
            </b-field>
          </b-field>
        </div>
      </template>
    </div>
    <b-modal v-model="popUpInformationTarif" width="900px" has-modal-card class="modal">
      <informationTarifsTlpe v-if="popUpInformationTarif"
                             :typeTaxationTlpeId="getMateriel.typeTaxationTlpeId"
                             :surfaceTlpe="getSurfaceTlpe"
                             :surfaceCommerciale="getSurfaceCommerciale">
      </informationTarifsTlpe>
    </b-modal>
    <b-modal v-model="popUpAjoutProduitDivers" width="900px" has-modal-card class="modal">
      <popUpAjoutProduitDivers v-if="popUpAjoutProduitDivers"
                               @produitCreated="closeAndAddProduit"
                             :produit="newProduitDivers">
      </popUpAjoutProduitDivers>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { get as getProduitLocation, getAll as getAllProduitLocation } from '@/api/produit/produitLocation';
import { get as getProduitDivers, getAll as getAllProduitDivers } from '@/api/produit/produitDivers';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import inputCurrency from '@/components/general/inputCurrency';
import * as devisConf from '@/configuration/devisConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import messageErreur from '@/services/general/messageErreur';
import messageInfo from '@/services/general/messageInformation';
import informationTarifsTlpe from '@/components/gabed/materiel/p_informationTarifsTlpe';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import deleteIdOfLiaisonsTarif from '@/services/catalogue/deleteIdOfLiaisonsTarif';
import genererProduitDivers from '@/services/catalogue/genererProduitDivers';
import popUpAjoutProduitDivers from '@/components/catalogue/produitGeneral/popUpAjoutProduitDivers';

const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    produit: {
      type: Object,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
    produitType: {
      type: String,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
    materiel: {
      type: Object,
    },
    face: {
      type: Object,
    },
    sens: {
      type: String,
      required: true,
    },
    dateDebutDefault: {
      type: [Date, String],
      required: false,
    },
    dateFinDefault: {
      type: [Date, String],
      required: false,
    },
  },
  components: {
    inputCurrency,
    informationTarifsTlpe,
    popUpAjoutProduitDivers,
  },
  data: () => ({
    autocompleteInput: '',
    isFetching: false,
    autocompleteProduitsList: [],
    permCatalogue: CATALOGUE,
    listeUniteQuantite: devisConf.LISTE_UNITES,
    popUpInformationTarif: false,
    popUpAjoutProduitDivers: false,
    newProduitDivers: null,
  }),
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    produitVide() {
      return !(this.produit.location || this.produit.divers);
    },
    isProduitFace() {
      return this.produitType === produitConf.CATEGORIE_UNITAIRE;
    },
    isProduitReseauTempo() {
      return this.produitType === produitConf.CATEGORIE_REGROUPEMENT;
    },
    isProduitEcranNum() {
      return this.produitType === produitConf.CATEGORIE_ECRAN_NUMERIQUE;
    },
    produitLocation() {
      return this.produit.location;
    },
    produitDivers() {
      return this.produit.divers;
    },
    produitArchive() {
      return this.produit.archive;
    },
    startDateHasError() {
      return !this.produit.dateDebut && this.$parent.$parent.error;
    },
    checkIfIsDisabled() {
      return this.isDisabled;
    },
    getTypeTaxationTlpeId() {
      if (this.isProduitFace || this.isProduitEcranNum) return this.getMateriel.typeTaxationTlpeId;
      return null;
    },
    getMateriel() {
      return this.isProduitFace ? this.face.materiel : this.materiel;
    },
    materielsFormat() {
      return this.parametre(PARAMETRES_KEYS.materielFormat);
    },
    getSurfaceTlpe() {
      const materielInProduct = this.getMateriel;
      if (materielInProduct.surface.surfaceTlpe !== null) {
        return materielInProduct.surface.surfaceTlpe;
      }
      const formatFind = this.materielsFormat.find((materielFormat) => {
        return materielFormat.id === this.getMateriel.formatId;
      });
      return formatFind ? formatFind.surface.surfaceTlpe : null;
    },
    getSurfaceCommerciale() {
      const materielInProduct = this.getMateriel;
      if (materielInProduct.surface.surfaceCommerciale !== null) {
        return materielInProduct.surface.surfaceCommerciale;
      }
      const formatFind = this.materielsFormat.find((materielFormat) => {
        return materielFormat.id === this.getMateriel.formatId;
      });
      return formatFind ? formatFind.surface.surfaceCommerciale : null;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    async addProduitDivers() {
      this.newProduitDivers = await genererProduitDivers(devisConf.SENS_VENTE);
      this.popUpAjoutProduitDivers = true;
    },
    onFocus() {
      this.getAsyncProduitData();
    },
    closeAndAddProduit(produit) {
      this.selectProduit(produit);
      this.popUpAjoutProduitDivers = false;
    },
    updateCalculAuto(produitEnfant) {
      if (!produitEnfant.calculAutomatique) return;
      produitEnfant.prixUnitaire = null;
      produitEnfant.quantite = 1;
      produitEnfant.unite = devisConf.UNITE;
      if (!this.isProduitFace && !this.isProduitEcranNum) return;
      if (!this.getMateriel.typeTaxationTlpeId) {
        messageInfo(this.$i18n.t('catalogue.info.missingInfoForCalculAutoTypeTaxationTlpe', {
          faceOrMateriel: this.face ? this.$i18n.t('catalogue.faceMateriel.face') : this.$i18n.t('catalogue.faceMateriel.materiel'),
        }));
      }
      if (!this.getSurfaceTlpe) {
        messageInfo(this.$i18n.t('catalogue.info.missingInfoForCalculAutoSurfaceTlpe', {
          faceOrMateriel: this.face ? this.$i18n.t('catalogue.faceMateriel.face') : this.$i18n.t('catalogue.faceMateriel.materiel'),
        }));
      }
    },
    getLibelleAndRoutesForProduct(produit) {
      const produitConfiguration = produitConf.CATEGORIE_PRODUIT.find(
        (produitObject) => {
          return produitObject.code === produit.supportCommercial.categorieVente;
        },
      );
      if (!produitConfiguration) return '';
      if (produitConfiguration.code !== produitConf.CATEGORIE_LOCATION) return produitConfiguration;
      return produit.numerique ? produitConfiguration.numerique : produitConfiguration.nonNumerique;
    },
    displaySwitchCalculAutoTlpe(liaison, isFirstLigneLiaisonTarif) {
      return !!((isFirstLigneLiaisonTarif
        && this.produitType === produitConf.CATEGORIE_LOCATION
        && liaison.produitEnfant.produitDivers.tlpe)
      || (!isFirstLigneLiaisonTarif && liaison.produitEnfant.produitDivers.tlpe
        && ((this.isProduitFace && this.face)
          || (this.isProduitEcranNum && this.materiel)
          || (!this.isProduitFace && !this.isProduitEcranNum))));
    },
    displaySwitchTarifUnitaire() {
      return this.produitType === produitConf.CATEGORIE_REGROUPEMENT;
    },
    supprimerProduitLigne() {
      this.$emit('suppressionLigne');
    },
    archiveProduitLigne() {
      this.produit.archive = true;
    },
    async getAsyncProduitData() {
      this.isFetching = true;
      this.autocompleteProduitsList = [];
      const result = {
        query: {
          libelle: this.produit.input,
          societeId: this.societeId,
          sens: this.sens,
        },
      };
      const responseDivers = await getAllProduitDivers(result);
      const diversArray = responseDivers.data.result.items;
      if (this.produitType !== produitConf.CATEGORIE_LOCATION
        && this.produitType !== produitConf.CATEGORIE_REGROUPEMENT_MAIRIE
        && this.produitType !== produitConf.CATEGORIE_DIVERS
        && this.produitType !== produitConf.CATEGORIE_AUTRE
        && this.produitType !== produitConf.CATEGORIE_SPONSORING
        && this.produitType !== produitConf.CATEGORIE_SALON) {
        const responseLocation = await getAllProduitLocation(result);
        const locationArray = responseLocation.data.result.items;
        this.autocompleteProduitsList = locationArray.concat(diversArray);
      } else {
        this.autocompleteProduitsList = diversArray;
      }
      this.isFetching = false;
      this.autocompleteProduitsList.forEach(item => {
        item.label = item.libelle + ' - ' + item.reference;
      });
    },
    async selectProduit(produit) {
      if (produit) {
        const loadingComponent = this.$buefy.loading.open();
        try {
          let response = null;
          if (produit.produitLocation) {
            response = await getProduitLocation(produit.id);
          } else if (produit.produitDivers) {
            response = await getProduitDivers(produit.id);
          }
          if (response) {
            this.formatSelectedProduit(response.data.result);
          } else {
            throw new Error();
          }
          loadingComponent.close();
        } catch (e) {
          messageErreur(this.$i18n);
          loadingComponent.close();
          throw e;
        }
      }
    },
    unite(code) {
      const unite = this.listeUniteQuantite.find(item => {
        return item.code === code;
      });
      if (unite) {
        return unite.initiale;
      }
      return 'general.quantity.initialUnity';
    },
    formatSelectedProduit(result) {
      if (result.produitDivers) {
        this.$set(this.produit, 'divers', true);
        this.produit.quantite = result.produitDivers.quantite;
        this.produit.uniteVente = result.produitDivers.uniteVente;
        this.$set(this.produit, 'prixUnitaire', result.produitDivers.prixUnitaire);
      }
      if (result.produitLocation) {
        this.$set(this.produit, 'location', true);
        this.produit.quantite = result.produitLocation.quantite;
        this.produit.uniteVente = result.produitLocation.uniteVente;
        this.$set(this.produit, 'prixUnitaire', result.produitLocation.prixUnitaire);
      }
      this.$set(this.produit, 'liaisonsTarif', result.liaisonsTarif);
      this.produit.libelle = result.libelle + ' - ' + result.reference;
      this.$set(this.produit, 'dateDebut', this.dateDebutDefault ? new Date(this.dateDebutDefault) : new Date());
      this.$set(this.produit, 'dateFin', this.dateFinDefault ? new Date(this.dateFinDefault) : null);
      this.produit.produitEnfantId = result.id;
      this.$set(this.produit, 'archive', false);
      this.$set(this.produit, 'produitEnfant', {
        supportCommercial: result.supportCommercial,
        produitDivers: result.produitDivers,
      });
      deleteIdOfLiaisonsTarif(result);
      this.$emit('ajoutDropdownProduitDefault', result.id, this.produit.libelle, result.produitLocation, result.supportCommercial.societeId);
    },
  },
  async mounted() {
    try {
      await this.loadParametres([PARAMETRES_KEYS.materielFormat]);
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
